export const isDeleteAllowed = (diskStatus: string): boolean => {
  return ["available", "error"].includes(diskStatus);
};

export type Resources = Map<string, { dataIndex: number }>;

export const isDeleteRequestInvalid = (data: { diskStatus: string }[], resources: Resources): boolean => {
  for (const value of Array.from(resources.values())) {
    if (!isDeleteAllowed(data[value.dataIndex]?.diskStatus)) {
      return true;
    }
  }

  return false;
};
